import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";

//Actions
import { cloudLoginPageConfirmToSave, clearRedux } from "Redux/actions";

const ConfirmToSave = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const { language } = props;

    const { confirmToSaveOpenModal } = useSelector(state => state.loginPageMainRedux)

    const closeModal = () => {
        dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { confirmToSave: false, confirmToSaveOpenModal: false }))
    }

    const handleConfirm = () => {
        dispatch(cloudLoginPageConfirmToSave(true))
    }

    return (
        <Modal
            open={confirmToSaveOpenModal}
            title={messages['create_template_confirm_to_save']}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <p>{`${messages['create_template_save_cloud_login_page_for']} ${language?.label}?`}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => handleConfirm()}
                >
                    {messages['create_template_confirm']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmToSave;